import styled from "styled-components";
import { FormatDecimal } from "../../library/core/formats";
import { InputNumber } from "../form/input-number";
import { GetEventInputValue } from "../form/core";
import { useState, useRef, useEffect } from "react";
import { PrimaryButton } from "../form/primary-button";
import { InvalidInputMessage } from "../form/invalid-input";
import FixedBottomButton  from "../form/FixedBottomButton";
const SpanBlock = styled.span`
  display: inline-block;
  padding: 0 3px;
`;

const TotalBillCaption = styled.div`
  font-size: 1rem;
`;

const SuccessMessage = ({ totalBillAmount, totalRedeemed, digits }) => {
  digits = digits || 2;
  totalRedeemed ||= 0;
  if (totalRedeemed === 0) {
    return (
      <TotalBillCaption>
        Balance to collect is{" "}
        <SpanBlock>${FormatDecimal(totalBillAmount, digits)}</SpanBlock>
      </TotalBillCaption>
    );
  } else if (totalRedeemed >= totalBillAmount)
    return (
      <TotalBillCaption>
        Successfully redeemed total amount of{" "}
        <SpanBlock>${FormatDecimal(totalRedeemed, digits)}</SpanBlock>
      </TotalBillCaption>
    );
  else
    return (
      <TotalBillCaption>
        <SpanBlock> ${FormatDecimal(totalRedeemed, digits)} </SpanBlock>
        successfully redeemed. Balance to collect is{" "}
        <SpanBlock>
          ${FormatDecimal(totalBillAmount - totalRedeemed, digits)}
        </SpanBlock>
      </TotalBillCaption>
    );
};

const totalBillField = {
  name: "totalBillAmount",
  label: " ",
  type: "number",
  required: true,
  validate: (value, dataModel) => {
    if (value <= 0 || value < dataModel.amount)
      return `Total bill amount should be greater than redeemed amount`;
    if (value > 5000)
      return `Total bill amount must be less than or equal to 5000`;
    return null;
  },
};

export const CaptureTotalBillAmount = ({ onSetTotalBillAmount }) => {
  const billNumberRef = useRef(null);
  const [model, setModel] = useState({});
  const [errors, setErrors] = useState({});
  const buttonRef = useRef(null);
  useEffect(() => {
    if (buttonRef?.current) {
      buttonRef.current.focus();
    }
  }, []);

  const onChangeHandler = (event) => {
    setModel({
      ...model,
      [event.target.name]: GetEventInputValue(event, true),
    });
    setErrors({});
  };

  const onSubmit = () => {
    if (
      model.totalBillAmount == null ||
      model.totalBillAmount <= 0 ||
      model.totalBillAmount > 5000
    ) {
      if (model.totalBillAmount > 5000) {
        setErrors({
          totalBillAmount:
            "Total bill amount must be less than or equal to 5000",
        });
      }
      if (billNumberRef?.current) {
        billNumberRef.current.focus();
        billNumberRef.current.select();
      }
      return;
    }

    onSetTotalBillAmount &&
      onSetTotalBillAmount({
        totalBillAmount: parseFloat(model.totalBillAmount),
      });
  };

  return (
    <div>
      <h1 className="text-center font-headings-primary font-medium text-[28px] leading-[33.6px] mb-2 mt-[30vh]">
        Enter total bill amount
      </h1>
      <div>
        <p className="text-center mb-4 text-[16px] font-body-primary">
          What’s the total before any redemption?
        </p>
      </div>
      <InputNumber
        ref={billNumberRef}
        className="md:max-w-[500px] mx-auto"
        key={totalBillField.name}
        dataModel={model}
        inputMode="numeric"
        {...totalBillField}
        errorsModel={errors}
        onChange={onChangeHandler}
        decimal={2}
        prefix="$"
        allowNegative={false}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Go" || e.key === "Done") {
            onSubmit();
          }
        }}
        onInput={(e) => {
          if (e.inputType === "insertLineBreak") {
            onSubmit();
          }
        }}
      />
      <FixedBottomButton classNameMobile="block min-[880px]:hidden fixed left-0 w-full z-50 bg-black/80 px-2 pb-4 pt-2 bottom-[calc(80px_+_env(safe-area-inset-bottom,0px))]">
      
        <PrimaryButton
          ref={buttonRef}
          className="md:max-w-[500px] mx-auto mt-5"
          onClick={onSubmit}
          disabled={!model.totalBillAmount || model.totalBillAmount <= 0}
        >
          Next
        </PrimaryButton>
      </FixedBottomButton>
    </div>
  );
};
